$(document).ready(function () {
    //Burger menu
    $('.js-show-mobile-nav').click(function () {
        $(this).toggleClass('open');
        $('.js-heading-links').toggleClass('active');
        $('.js-mobile-nav')./*slideToggle().*/toggleClass('open');
        // Header's .dark/.light stays purely scroll-driven (brightness.js) -
        // no override here, opening the nav doesn't change it either way.
    });

    // Show/hide mobile header menu
    var headerNav = $('.js-expand-mobile-nav');
    headerNav.click(function (e) {

        var sub_menu = $(this).next('.js-mobile-sub-menu');
        var symbol = $(this).find('.js-mobile-expand-symbol');

        symbol.html(function (i, text) {
            return text === "<span>+</span>" ? "<span>-</span>" : "<span>+</span>";
        });
        symbol.toggleClass('expanded');

        //sub_menu.slideToggle();
        sub_menu.toggleClass('open');
        //sub_menu.toggleClass('active');
    });

    function toggleServicesDropdown() {
        var $item = $(this).closest('.js-parent-menu-item');
        var dropdown_symbol = $item.find('.js-dropdown-symbol');

        $item.toggleClass("active");
        $(".js-heading-links").toggleClass("active");
        dropdown_symbol.toggleClass("minus");
        dropdown_symbol.html(function (i, text) {
            return text === "<span>+</span>" ? "<span>-</span>" : "<span>+</span>";
        });
        // Header's .dark/.light stays purely scroll-driven (brightness.js) -
        // no override here, opening the dropdown doesn't change it either way.
    }

    $(".js-parent-menu-item").on('click', toggleServicesDropdown);

    // Belt-and-braces: click the "+"/"-" circle directly rather than
    // relying only on it bubbling up to .js-parent-menu-item above -
    // stopPropagation so it doesn't also then bubble into that same
    // handler and toggle a second time (net effect: nothing visibly
    // happens, since the two toggles cancel out).
    $(".js-dropdown-symbol").on('click', function (e) {
        e.stopPropagation();
        toggleServicesDropdown.call(this);
    });

    // Compact desktop dropdown: close it on an outside click or Escape,
    // since (unlike the old full-overlay mega menu) most of the page stays
    // visible and clickable while it's open.
    $(document).on('click', function (e) {
        var openItem = $('.js-parent-menu-item.active');

        if (openItem.length && !$(e.target).closest('.js-parent-menu-item').length) {
            openItem.trigger('click');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            $('.js-parent-menu-item.active').trigger('click');
        }
    });

    /*$('.js-hover-image').on('mousemove', function (e) {
        var $this = $(this);
        var rect = this.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var deltaX = (centerX - x) * 0.05; // Adjust the factor here to control the movement sensitivity
        var deltaY = (centerY - y) * 0.05; // Adjust the factor here to control the movement sensitivity

        // Ensure the displacement is capped at 10px in any direction
        var moveX = Math.max(-10, Math.min(10, deltaX));
        var moveY = Math.max(-10, Math.min(10, deltaY));

        $this.find('img').css('transform', 'scale(1.2) translate(' + moveX + 'px, ' + moveY + 'px)');
    }).on('mouseleave', function () {
        $(this).find('img').css('transform', 'scale(1.2) translate(0, 0)'); // Reset position when the mouse leaves
    });*/

});


